<template>
  <div class="loading" v-show="$store.store.state.loading">
    <div class="overlay" :style="overlayPosition">
      <div class="child">
        <vue-loading
          type="spiningDubbles"
          color="#1198BB"
          :size="{ width: '150px', height: '150px' }"
          >
        </vue-loading>
        <div class="message-box">
          <p>Loading...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueLoading } from 'vue-loading-template'

export default {
  components: {
    VueLoading
  },
  data () {
    return {
      overlayPosition: {
        top: '0'
      }
    }
  },
  watch: {
    '$store.store.state.loading': function (newVal) {
      // スクロールされていても表示領域いっぱいに
      // オーバレイが表示されるように高さを調整する
      if (newVal) {
        this.overlayPosition.top = window.pageYOffset + 'px'
      }
    }
  }
}
</script>

<style>
.overlay {
  background-color: rgba(0, 0, 0, 0.75);
  /* 画面いっぱいに広げる */
  position: absolute;
  height: 100vh;
  width: 100vw;
  left: 0;
  top: 0;
  /* 子要素を上下左右に中央寄せ */
  display: inline-block;
  align-items: center;
  justify-content: center;
}

.child {
  text-align:center;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%, -50%);
}

.message-box {
  color: #fff;
  animation-name: blink;
  animation-duration: 600ms;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
  animation-iteration-count: infinite;
}

.loading-spacer {
  height: 30%;
}

@keyframes blink {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue